import { Tabs } from "@closer/ui";
import { Outlet, useLocation, useNavigate } from "react-router";

import { useAuth } from "../../lib/authContext";
import { visibleContractSections } from "../../lib/contractSections";

/**
 * Sözleşmeler kabuğu (D02 — CLOS-625).
 *
 * Şablonlar kanonik bilgi mimarisinde Sözleşmeler'in ALT SAYFASI; sidebar'a ikinci bir üst
 * düzey öğe eklemek kanonik sırayı bozardı. Kabuk EP13'teki `OrganizationLayout` deseninin
 * aynısı — yeni bir desen icat edilmedi (refleks 1).
 *
 * Bölümler AYRI ROTALAR, sekme durumu değil: kullanıcı şablon kütüphanesini bir bağlantı
 * olarak paylaşabilmeli ve yenilemede bağlam kaybolmamalı.
 *
 * Hangi bölümlerin çizileceği `lib/contractSections.ts` kaydından ve yetki filtresi oradaki
 * tek kuraldan geliyor — bu bileşen "hangi sayfalar var" sorusunu bilmiyor.
 */
export function ContractsLayout() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const sections = visibleContractSections(can);

  return (
    <div className="flex w-full flex-col gap-6">
      {/* Tek bölüm görünüyorsa gezinme çizmek anlamsız: tıklanacak bir yer yok. */}
      {sections.length > 1 ? (
        <Tabs
          label="Sözleşmeler"
          items={sections.map((section) => ({ key: section.key, label: section.label }))}
          activeKey={sections.find((s) => s.route === location.pathname)?.key ?? null}
          onSelect={(key) => {
            const hedef = sections.find((s) => s.key === key);
            if (hedef) void navigate(hedef.route);
          }}
        />
      ) : null}
      <Outlet />
    </div>
  );
}
